import React, { useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import SimpleSelect from "../../../components/selects/simpleSelect";
import {
  callActionApiAsync,
  postAddBiomedicalEquipmentModel
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const validationSchema = yup.object().shape({
  brandId: yup
    .number()
    .typeError("Seleccione una marca")
    .required("Seleccione una marca"),
  name: yup.string().required("Este campo es obligatorio")
});

const AddModelModal = ({ open, close, brands, userId, onSaved }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warning",
    summary: "",
    detail: ""
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { brandId: "", name: "" }
  });

  const handleClose = () => {
    reset();
    close();
  };

  const onSubmit = async (formData) => {
    await callActionApiAsync(
      () =>
        postAddBiomedicalEquipmentModel({
          userId,
          brandId: formData.brandId,
          name: formData.name
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (error) => {
        setToastConfig({
          severity: "error",
          summary: "Error de creación",
          detail:
            typeof error === "string" && error
              ? error
              : "No se pudo crear el modelo."
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Crear modelo"
        actions={<div className="HContainer j-center w-complete"></div>}
        width="100%"
        maxWidth="640px"
      >
        <div className="HContainer">
          <form className="VContainer align-center m-20 w-complete">
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <p className="create-label">Marca:</p>
                <SimpleSelect
                  name="brandId"
                  control={control}
                  options={brands}
                  error={errors.brandId}
                  hideLabel
                  margin="0"
                />
              </Grid>
              <Grid item xs={12}>
                <p className="create-label">Nombre del modelo:</p>
                <FormTextField
                  name="name"
                  control={control}
                  error={errors.name}
                />
              </Grid>
            </Grid>
            <LaddaButton
              width={"180px"}
              fontSize={"12px"}
              height={"32px"}
              variant="contained"
              margin={"20px 0"}
              type="button"
              onClick={handleSubmit(onSubmit)}
            >
              <p className="button_text">Crear modelo</p>
            </LaddaButton>
          </form>
        </div>
      </ModalComponent>
      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </>
  );
};

export default AddModelModal;
